<template>
  <div>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="18">
        <el-form-item label="姓名" prop="contactPersonName" style="text-align: left" :class="checkNameChange('contactPersonName', formData.contactPersonName)? 'redItem' : null">
          <el-input v-model="formData.contactPersonName" style="width: 70%" auto-complete="off" maxlength="25"
                    :disabled="disabled"></el-input>
          <span style="color: red">（协会对接联系人）</span>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="18">
        <el-form-item label="职务" prop="contactPersonDuty"
                      :class="checkNameChange('contactPersonDuty', formData.contactPersonDuty)? 'redItem' : null">
          <el-input v-model="formData.contactPersonDuty" auto-complete="off" maxlength="25"
                    :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="18">
        <el-form-item label="性别" prop="contactPersonSex" style="text-align: left"
                      :class="checkNameChange('contactPersonSex', formData.contactPersonSex)? 'redItem' : null">
          <el-radio-group v-model="formData.contactPersonSex">
            <el-radio label="男" :disabled="disabled"></el-radio>
            <el-radio label="女" :disabled="disabled"></el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="18">
        <el-form-item label="身份证号码" prop="contactPersonIdcardNo"
                      :class="checkNameChange('contactPersonIdcardNo', formData.contactPersonIdcardNo)? 'redItem' : null">
          <el-input v-model="formData.contactPersonIdcardNo" auto-complete="off" maxlength="20"
                    :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="18">
        <el-form-item label="政治面貌" prop="contactPersonPoliticalStatus"
                      :class="checkNameChange('contactPersonPoliticalStatus', formData.contactPersonPoliticalStatus)? 'redItem' : null">
          <el-input v-model="formData.contactPersonPoliticalStatus" auto-complete="off" maxlength="5"
                    :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="18">
        <el-form-item label="联系电话" prop="contactPersonOfficeTel" :class="checkNameChange('contactPersonOfficeTel', formData.contactPersonOfficeTel)? 'redItem' : null">
          <el-input v-model="formData.contactPersonOfficeTel" auto-complete="off" maxlength="15"
                    :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="18">
        <el-form-item label="手机号" prop="contactPersonMobile"
                      :class="checkNameChange('contactPersonMobile', formData.contactPersonMobile)? 'redItem' : null">
          <el-input v-model="formData.contactPersonMobile" auto-complete="off" maxlength="15"
                    :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import MessagePanel from "../Core/MessagePanel";

  export default {
    name: "ContactPerson",
    components: {MessagePanel},
    props: ["formData", "disabled"],
    methods: {
      checkNameChange(fieldName, value) {
        let flag = false
        if (this.formData.oldContent) {
          for (let key in this.formData.oldContent) {
            if (key == fieldName && value != this.formData.oldContent[key]) {
              flag = true
              break // break跳出循环
            }
          }
        }
        return flag
      },
    }
  }
</script>

<style scoped lang="less">
  .redItem /deep/ .el-form-item__label{
    color: red !important;
  }
  .redItem /deep/ .el-input__inner{
    color: red !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Member/ContactPerson.vue